import { Button, Group, NumberInput, Paper, Stack, Text, Title } from "@mantine/core";
import { IMCBIMAPI } from "@mctypes/mcbim.types";
import { IconDeviceFloppy } from "@tabler/icons-react";
import React, { useState } from "react";

const McBimVersionCount: React.FC<{
  mcBimProject: IMCBIMAPI.Project;
  disabled: boolean;
  onSave: (versionCount: number) => void;
}> = ({ mcBimProject, disabled, onSave }) => {
  const [saveEnabled, setSaveEnabled] = useState<boolean>(false);
  const [versionCount, setVersionCount] = useState<string>(
    mcBimProject?.fileVersionCount != null ? mcBimProject?.fileVersionCount.toString() : "",
  );

  const updateMaxVersionCount = async () => {
    const shouldSave = window.confirm(
      `Er du sikker på at du vil oppdatere maksimalt antall versjoner? Dersom antall versjoner overskrider ${versionCount} vil eldre versjoner slettes daglig.`,
    );
    if (!shouldSave) {
      return;
    }
    onSave(Number(versionCount));
    validateNumber(mcBimProject?.fileVersionCount?.toString());
  };

  const validateNumber = (count: string) => {
    const num = Number(count);
    const current = Number(mcBimProject?.fileVersionCount);
    const enabled = current !== num && /^\d+$/.test(count) && num > 0 && num <= 10;
    setSaveEnabled(enabled);
    setVersionCount(count);
  };

  return (
    <Paper withBorder radius="md" p="md">
      <Stack gap="sm">
        <div>
          <Title order={4}>Maksimalt antall versjoner</Title>
          <Text c="dimmed" size="sm">
          Hvis det finnes flere versjoner enn det maksimale antallet, vil de eldste versjonene bli fjernet
          </Text>
        </div>
        <Group align="flex-end">
          <NumberInput
            disabled={disabled === true}
            min={1}
            max={10}
            w="7rem"
            value={versionCount}
            onChange={(value) => validateNumber(String(value ?? ""))}
          />
          <Button
            color="green"
            disabled={disabled === true || saveEnabled === false}
            leftSection={<IconDeviceFloppy size={16} />}
            onClick={updateMaxVersionCount}
          >
            Lagre
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
};

export default McBimVersionCount;
